import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
export function Title(t0) {
  const $ = _c(3);
  const {
    id
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      letterSpacing: "0.05rem",
      fontWeight: 450
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== id) {
    t2 = <Typography component="span" id={id} sx={t1}>ON THIS PAGE</Typography>;
    $[1] = id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}